var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWechatPayLogotype(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 55,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.731 31.735a1.165 1.165 0 0 1-1.546-.475l-.072-.17-3.187-7.078a.591.591 0 0 1 .527-.846c.132 0 .25.045.352.12l3.758 2.707c.27.185.6.29.952.29.213 0 .41-.038.6-.112l17.677-7.96c-3.165-3.784-8.388-6.254-14.292-6.254-9.67 0-17.5 6.61-17.5 14.77 0 4.452 2.359 8.458 6.043 11.166.293.215.491.563.491.964 0 .134-.03.252-.058.379-.293 1.112-.77 2.893-.792 2.982-.036.14-.095.282-.095.43 0 .327.264.594.586.594a.63.63 0 0 0 .337-.112l3.831-2.24c.286-.17.594-.275.93-.275.176 0 .352.03.513.082 1.788.52 3.714.809 5.714.809 9.662 0 17.5-6.61 17.5-14.771 0-2.47-.725-4.8-1.992-6.848L12.856 31.661l-.125.074Z",
    fill: "#979797"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWechatPayLogotype);
export default __webpack_public_path__ + "static/media/wechat-pay-logotype.eaefcde1f756fb5a6a113fb21c131df0.svg";
export { ForwardRef as ReactComponent };